/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error_code: NonNullable<unknown> }} Dialog_Unexpected_Error_ContentInputs */

const en_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please try again later or contact customer support. Error code: ${i?.error_code}`)
};

const ar_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يرجى المحاولة مرة أخرى لاحقًا أو الاتصال بدعم العملاء. رمز الخطأ: ${i?.error_code}`)
};

const de_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bitte versuchen Sie es später noch einmal oder wenden Sie sich an den Kundensupport. Fehlercode: ${i?.error_code}`)
};

const es_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuelve a intentarlo más tarde o ponte en contacto con el servicio de atención al cliente. Código de error: ${i?.error_code}`)
};

const fr_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer ultérieurement ou contactez le service client. Code d'erreur: ${i?.error_code}`)
};

const it_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riprova più tardi o contatta l'assistenza clienti. Codice di errore: ${i?.error_code}`)
};

const ja_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`しばらくしてからもう一度お試しいただくか、カスタマーサポートにお問い合わせください。エラーコード：${i?.error_code}`)
};

const ko_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`나중에 다시 시도하거나 고객센터에 문의하세요. 오류 코드: ${i?.error_code}`)
};

const pt_br_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tente novamente mais tarde ou contate o suporte. Código de erro: ${i?.error_code}`)
};

const ru_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Повторите попытку позже или обратитесь в службу поддержки. Код ошибки: ${i?.error_code}`)
};

const th_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุนลูกค้า รหัสข้อผิดพลาด: ${i?.error_code}`)
};

const tr_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lütfen daha sonra tekrar dene veya müşteri hizmetleriyle iletişime geç. Hata kodu: ${i?.error_code}`)
};

const zh_cn_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请稍后重试或联系客服。错误代码：${i?.error_code}`)
};

const zh_tw_dialog_unexpected_error_content = /** @type {(inputs: Dialog_Unexpected_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`請稍後重試或聯繫客服。錯誤代碼：${i?.error_code}`)
};

/**
* | output |
* | --- |
* | "Please try again later or contact customer support. Error code: {error_code}" |
*
* @param {Dialog_Unexpected_Error_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_unexpected_error_content = /** @type {((inputs: Dialog_Unexpected_Error_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Unexpected_Error_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_unexpected_error_content(inputs)
	if (locale === "ar") return ar_dialog_unexpected_error_content(inputs)
	if (locale === "de") return de_dialog_unexpected_error_content(inputs)
	if (locale === "es") return es_dialog_unexpected_error_content(inputs)
	if (locale === "fr") return fr_dialog_unexpected_error_content(inputs)
	if (locale === "it") return it_dialog_unexpected_error_content(inputs)
	if (locale === "ja") return ja_dialog_unexpected_error_content(inputs)
	if (locale === "ko") return ko_dialog_unexpected_error_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_unexpected_error_content(inputs)
	if (locale === "ru") return ru_dialog_unexpected_error_content(inputs)
	if (locale === "th") return th_dialog_unexpected_error_content(inputs)
	if (locale === "tr") return tr_dialog_unexpected_error_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_unexpected_error_content(inputs)
	return zh_tw_dialog_unexpected_error_content(inputs)
});